<template>
  <div class="fill-height photo-exhibition-page">
    <transition mode="out-in">
      <PhotoExhibitionRoom :slug="slug" v-if="!artist" key="room" :preloaded-image="preloadedImage" />
      <PhotoExhibitionGallery :slug="slug" :artist="artist" :index="index" v-else key="gallery" />
    </transition>
  </div>
</template>

<script>
import PhotoExhibitionRoom from '@/organisms/PhotoExhibitionRoom'
import PhotoExhibitionGallery from '@/organisms/PhotoExhibitionGallery'
export default {
  name: 'PhotoExhibition',
  components: {
    PhotoExhibitionRoom,
    PhotoExhibitionGallery
  },
  data () {
    return {
    }
  },
  props: {
    slug: {
      required: true,
      type: String
    },
    artist: {
      required: false,
      type: String
    },
    index: {
      required: false,
      type: String
    },
    preloadedImage: {
      required: false,
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-exhibition-page {
  overflow-x: hidden;
}
</style>
